import { EnvironmentConfig } from './types';

export const productionConfig: EnvironmentConfig = {
  // Environment identification
  environment: 'production',
  
  // API Configuration - Production API Gateway
  apiBaseUrl: 'https://api.streaming-platform.com',
  apiTimeout: 20000,
  
  // Authentication Configuration (Production Cognito Pool)
  cognitoUserPoolId: 'us-east-1_prod123456',
  cognitoUserPoolClientId: 'prod-client-id-123456',
  cognitoHostedUiUrl: 'https://streaming-platform.auth.us-east-1.amazoncognito.com',
  cognitoRegion: 'us-east-1',
  
  // CDN and Asset Configuration - Production CloudFront
  imagesCdnUrl: 'https://d0987654321xyz.cloudfront.net/images',
  staticAssetsCdnUrl: 'https://streaming-platform.com',
  
  // Feature Flags - Production optimized
  enableDebugMode: false,
  enableAnalytics: true,
  enablePerformanceMonitoring: true,
  enableErrorReporting: true,
  
  // Development Tools - Disabled for production
  enableDevTools: false,
  enableHotReload: false,
  
  // Security Configuration - Full security enabled
  enableCSP: true,
  allowedOrigins: [
    'https://streaming-platform.com',
    'https://api.streaming-platform.com'
  ],
  
  // Performance Configuration - Production optimized
  enableServiceWorker: true,
  enableLazyLoading: true,
  maxRetries: 3,
  retryDelay: 2000,
};